import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { useReportingApi } from '../../../api'
import { fetchQueueAgents } from '../api/queueApi'
import type { QueueAgentsResponse } from '../types'
import { queueDashboardPollingOptions } from './queueDashboardPolling'

export const queueAgentsQueryKeys = {
  all: ['queueAgents'] as const,
  list: (pbxUuid: string, queueNumber: string | null) =>
    [...queueAgentsQueryKeys.all, pbxUuid, queueNumber] as const,
}

export interface UseQueueAgentsOptions {
  pbxUuid: string | null
  queueNumber: string | null
  refreshInterval: number
  enabled: boolean
  options?: Omit<
    UseQueryOptions<QueueAgentsResponse, Error>,
    'queryKey' | 'queryFn' | 'refetchInterval' | 'staleTime' | 'enabled'
  >
}

export const useQueueAgents = ({
  pbxUuid,
  queueNumber,
  refreshInterval,
  enabled,
  options = {},
}: UseQueueAgentsOptions) => {
  const api = useReportingApi()

  return useQuery<QueueAgentsResponse, Error>({
    queryKey: queueAgentsQueryKeys.list(pbxUuid ?? '', queueNumber),
    queryFn: async ({ signal }) =>
      fetchQueueAgents(api, pbxUuid!, queueNumber!, signal),
    enabled: !!pbxUuid && !!queueNumber && enabled,
    ...options,
    ...queueDashboardPollingOptions(enabled, refreshInterval),
  })
}

export default useQueueAgents
